
import { useSocket } from "store/chat/selectors";

const useSocketForSend = () => {
  const { socketConnection, reCreateSocket } = useSocket();

  const sendDataOnSocket = (data) => {
    if (socketConnection) {
      try {
        if (socketConnection.readyState == 3) {
          reCreateSocket();
          setTimeout(() => {
            socketConnection.send(JSON.stringify(data));
          }, 2000);
        } else {
          socketConnection.send(JSON.stringify(data));
        }
      } catch (error) {
        console.log(error, "error");
      }
    }
  };
  return { sendDataOnSocket };
};

export default useSocketForSend;
